module.exports = __webpack_public_path__ + "img/bannerCampaigns.eb54a9ad.png";